import React from 'react';
import Select from '../Select/Select';
import { CLIENT_CONTACT_PERSON_TYPES } from '../../constants';

const SelectContactType = ({ ...props }) => {
  return <Select options={CLIENT_CONTACT_PERSON_TYPES} label={'Ð¢Ð¸Ð¿ ÐºÐ¾Ð½ÑÐ°ÐºÑÐ½Ð¾Ð³Ð¾ Ð»Ð¸ÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectContactType;
